import './EditBed.scss'
import EditBed from "./EditBed";

export default EditBed;